import axios from 'axios';
import swal from '../swal';
import {
    getUserToken,
    clearUserinfo,
    fr
} from './query-params';
import {invokeLogin} from './postmessage';
import errorMsg from '../errorMsg';
// 设置全局axios默认值
axios.defaults.timeout = 15000; // 15000的超时验证
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

// 创建一个axios实例
const instance = axios.create({});
instance.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

axios.interceptors.request.use = instance.interceptors.request.use;

// request拦截器
instance.interceptors.request.use(
    config => {
        const token = getUserToken();

        if (token) {
            /* eslint no-param-reassign: "error" */
            config.headers.Authorization = token;
        }
        return config;
    },
    err => Promise.reject(err),
);

// respone拦截器
instance.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.config && error.response.config.handleErrorBySelf) {
            const {status} = error.response;
            if (status === 401) {
                clearUserinfo();
                invokeLogin(fr);
            } else {
                return;
            }
        }
        if (error.code === 'ECONNABORTED') {
            swal.swalAgent(error, errorMsg.ECONNABORTED);
            return Promise.reject(error.response);
        }

        if (error.message === 'Network Error') {
            swal.swalAgent(error, errorMsg.NETWORK_ERROR);
            return Promise.reject(error.response);
        }

        if (error.response) {
            const {status} = error.response;
            if (status === 401) {
                // if (fr !== 'community') swal.swalAgent(error, errorMsg.TOKEN_EXPIRED);
                clearUserinfo();
                invokeLogin(fr);
            }
        }
        return Promise.reject(error.response);
    },
);

export default instance;
